import FooterContentMainBottom from '../FooterContentMainBottom/FooterContentMainBottom';
import FooterContentMainTop from '../FooterContentMainTop/FooterContentMainTop';
import FooterDivider from '../FooterDivider/FooterDivider';
import styles from './styles.module.scss';

const FooterContentMain = () => (
  <>
    <FooterContentMainTop />
    <div className={styles.divider}>
      <FooterDivider />
    </div>
    <FooterContentMainBottom />
  </>
);

export default FooterContentMain;
